import React from 'react';
import { IconProps } from '../types';
const MinecraftOakSign: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="2" y="2" width="1" height="1" fill="rgba(194, 157, 98, 255)" />
<rect x="3" y="2" width="1" height="1" fill="rgba(194, 157, 98, 255)" />
<rect x="4" y="2" width="1" height="1" fill="rgba(184, 148, 95, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(184, 148, 95, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(184, 148, 95, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(184, 148, 95, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(194, 157, 98, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(184, 148, 95, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="14" y="2" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="2" y="3" width="1" height="1" fill="rgba(184, 148, 95, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(105, 84, 51, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(105, 84, 51, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(105, 84, 51, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="14" y="3" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(105, 84, 51, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(105, 84, 51, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="14" y="4" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="2" y="5" width="1" height="1" fill="rgba(194, 157, 98, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(159, 132, 77, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(184, 148, 95, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(105, 84, 51, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(105, 84, 51, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(105, 84, 51, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(105, 84, 51, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(105, 84, 51, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="14" y="6" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(105, 84, 51, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="14" y="7" width="1" height="1" fill="rgba(126, 98, 55, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(194, 157, 98, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(175, 143, 85, 255)" />
<rect x="14" y="8" width="1" height="1" fill="rgba(159, 132, 77, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="14" y="9" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(97, 74, 38, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(97, 74, 38, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(97, 74, 38, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(97, 74, 38, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(97, 74, 38, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(97, 74, 38, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(97, 74, 38, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(97, 74, 38, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(97, 74, 38, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(97, 74, 38, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(97, 74, 38, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(97, 74, 38, 255)" />
<rect x="14" y="10" width="1" height="1" fill="rgba(97, 74, 38, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(116, 90, 54, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(76, 61, 38, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(56, 43, 24, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(145, 113, 66, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(95, 74, 43, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(56, 43, 24, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(145, 113, 66, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(116, 90, 54, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(56, 43, 24, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(145, 113, 66, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(116, 90, 54, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(56, 43, 24, 255)" />
<rect x="7" y="15" width="1" height="1" fill="rgba(116, 90, 54, 255)" />
<rect x="8" y="15" width="1" height="1" fill="rgba(56, 43, 24, 255)" />
<rect x="9" y="15" width="1" height="1" fill="rgba(56, 43, 24, 255)" />
</svg>);
export default MinecraftOakSign;